import classNames from 'classnames';
import Cookies from 'js-cookie';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import insightsClient from 'search-insights';

import {
	SEARCH_CREDENTIALS,
	SearchScope,
} from '@app/services/constants/algolia';
import { updateSelectedModes as updateSelectedModesAction } from '@app/store/actions/app.actions';

import { Autocomplete } from './algolia-autocomplete';
import {
	MarketingTemplate,
	getMarketingTemplateConfig,
	marketingItems,
} from './marketing-template';
import { ProductItem } from './product-item';

type PropsDesktopUtilitySearch = {
	searchModes: SearchScope[];
	selectedModes: string[];
	updateSelectedModes: (newModes: string[]) => void;
};

interface AutocompleteTemplates {
	item: ({ item, components }: { item: any; components: any }) => JSX.Element;
	components: any;
}

const DesktopUtilitySearchComponent: React.FC<PropsDesktopUtilitySearch> = ({
	searchModes = [],
	selectedModes,
	updateSelectedModes,
}: PropsDesktopUtilitySearch) => {
	const searchFormRef = React.useRef<HTMLFormElement | null>(null);
	const [selectedMode, setSelectedMode] = React.useState(
		searchModes.find((mode) => mode.id === selectedModes[0]),
	);

	React.useEffect(() => {
		const cookieSelectedMode = Cookies.get('selectedMode');
		const newSelectedMode = searchModes.find(
			(mode) => mode.id === cookieSelectedMode || mode.id === selectedModes[0],
		);
		if (newSelectedMode) {
			if (cookieSelectedMode) {
				setSelectedMode(newSelectedMode);
			}
		}
	}, [selectedModes, searchModes]);

	const autocompleteTemplates: AutocompleteTemplates = {
		// eslint-disable-next-line react/prop-types
		item: ({ item, components }) => (
			<ProductItem hit={item} components={components} />
		),
		components: {},
	};

	const handleIndexChange = (e: { target: { value: string } }) => {
		const selectIndex = searchModes.find((mode) => mode.id === e.target.value);
		if (selectIndex) {
			// update global state
			updateSelectedModes([selectIndex.id]);
			// update local state
			setSelectedMode(selectIndex);
			// set the selected mode in a cookie to persist value across page refreshes
			Cookies.set('selectedMode', selectIndex.id, { secure: true });
		}
	};

	insightsClient('init', {
		appId: SEARCH_CREDENTIALS.appID,
		apiKey: SEARCH_CREDENTIALS.apiKey,
		useCookie: true,
	});

	return (
		<li className={classNames('u-hidden-tablet-max', 'utility-nav__item')}>
			<form ref={searchFormRef} className="desktop-search-form">
				<select
					value={selectedModes[0]}
					onChange={handleIndexChange}
					className="desktop-search-form__select desktop-search-form__item"
					aria-label="refine search scope"
				>
					<optgroup label="Search Scope">
						{searchModes.map((mode) => (
							<option key={mode.id} value={mode.id}>
								{mode.label}
							</option>
						))}
					</optgroup>
				</select>
				<div className="desktop-search-form__search-field desktop-search-form__item">
					<div className="container desktop-search-form__input">
						<Autocomplete
							className="desktop-search-form__input "
							openOnFocus
							selectedMode={selectedMode}
							getSources={() => [
								{
									sourceId: 'products',
									getItems() {
										return [];
									},
									templates: autocompleteTemplates,
								},
								getMarketingTemplateConfig(
									'marketing_template',
									marketingItems,
									{ item: MarketingTemplate },
								),
							]}
						/>
					</div>
				</div>
			</form>
		</li>
	);
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
	updateSelectedModes: (newModes: string[]) =>
		dispatch(updateSelectedModesAction(newModes)),
});
const mapStateToProps = (state: { app: { selectedModes: string[] } }) => ({
	selectedModes: state.app.selectedModes,
});

export const DesktopUtilitySearch = connect(
	mapStateToProps,
	mapDispatchToProps,
)(DesktopUtilitySearchComponent);
